import { AlertBox } from "@/components/AlertBox/AlertBox"
import { ArrowLink } from "@/components/ArrowLink/ArrowLink"
import { PrimaryButton } from "@/components/PrimaryButton/PrimaryButton"
import { GRichText } from "@/components/RichText/RichText"
import { useNotFound } from "@/lib/prismicio/useNotFound"
import { Link, NextImage, useI18n } from "@jog/react-components"
import { isFilled } from "@prismicio/helpers"
import { Container } from "components"

const PageNotFoundContent = () => {
    const { $t } = useI18n()
    const prismicContent = useNotFound()

    return (
        <Container className="mb-17.5 sm:max-xl:min-w-full">
            <div className="px-6.25 lg:px-0">
                <AlertBox type="error" text={$t("404 Page Not Found")} />
            </div>
            <div className="flex flex-wrap px-6.25 lg:flex-nowrap lg:px-0">
                <div className="basis-full lg:basis-7/12">
                    <h1 className="my-5.5 mx-0 font-primary text-22 font-normal">{prismicContent.title}</h1>
                    <h2 className="mx-0 mt-0 mb-5.5 font-primary text-base font-normal">{prismicContent.subtitle}</h2>
                    <div className="my-5.5 mx-0 text-sm">
                        {isFilled.richText(prismicContent.description) && (
                            <GRichText linkClass="text-black no-underline" field={prismicContent.description} />
                        )}
                    </div>
                    {prismicContent.links.map((link, index) => (
                        <ArrowLink key={index} href={link.link}>
                            {link.name}
                        </ArrowLink>
                    ))}
                </div>
                <div className="basis-full p-0 lg:basis-5/12">
                    {prismicContent.image ? (
                        <NextImage
                            blur={false}
                            src={prismicContent.image.src}
                            alt={prismicContent.image.alt}
                            className="h-auto w-full"
                            width={prismicContent.image.width}
                            height={prismicContent.image.height}
                        />
                    ) : null}
                </div>
            </div>
            <div className="px-6.25 lg:px-0">
                <Link href="/">
                    <PrimaryButton className="my-8 text-center">{$t("Continue shopping")}</PrimaryButton>
                </Link>
            </div>
        </Container>
    )
}

export default PageNotFoundContent
